export default {
    root: ({props, parent}) => ({
        class: [
            // Font
            "font-bold",
            {
                // 'text-xl': props.size === 'large',
                // 'text-2xl': props.size === 'xlarge'
            },

            // Alignments
            "inline-flex items-center justify-center flex-none",
            "relative",

            // Sizes
            {
                // 'h-8 w-8': props.size === null || props.size === 'normal',
                // 'w-12 h-12': props.size === 'large',
                // 'w-16 h-16': props.size === 'xlarge'
            },
            {"-ml-4": parent.instance.$style?.name === "avatargroup"},

            // Shapes
            {
                "rounded-lg": props.shape === "square",
                "rounded-full": props.shape === "circle",
            },
            {"border-2": parent.instance.$style?.name === "avatargroup"},
            "overflow-hidden",

            // Colors
            // 'bg-stone-300 dark:bg-stone-700',
            {"border-white dark:border-stone-800": parent.instance.$style?.name === "avatargroup"},
        ],
    }),
    image: ({props}) => ({
        class: [
            "object-cover h-full w-full",
            // {
            //     "rounded-lg": props.shape === "square",
            //     "rounded-full": props.shape === "circle",
            // },
        ],
    }),
};
